import { Unstable_Grid2 as Grid } from '@mui/material';

import { Switches, TextField, Select } from '@occc-app/design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { periodOptions } from './progress-per-period-limit.constants';

import { LimitFormContentLayout } from '../components/limit-form-content-layout';
import { LimitFormNamePaths } from '../types';

type ProgressPerPeriodLimitProps = {
  open: boolean;
};

export const ProgressPerPeriodLimit = ({ open }: ProgressPerPeriodLimitProps) => {
  return (
    <LimitFormContentLayout
      title='Progress Limit Per Period'
      description='Limit the progress a member can make on a offer over a specific time period'
      action={
        <Switches
          name={'awardCount.progressPerPeriod.isEnabled' satisfies LimitFormNamePaths}
          data={{}}
        />
      }
      open={open}
    >
      <Grid container spacing={3}>
        <Grid xs={3}>
          <TextField
            name={'awardCount.progressPerPeriod.limit' satisfies LimitFormNamePaths}
            label='Limit'
            fieldProps={{
              parse: parseNumber,
            }}
          />
        </Grid>

        <Grid xs={3}>
          <Select
            name={'awardCount.progressPerPeriod.timePeriod' satisfies LimitFormNamePaths}
            label='Frequency'
            data={periodOptions}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
      </Grid>
    </LimitFormContentLayout>
  );
};
